"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    stars: {
      padding: "6px 0",
      "& .star-container": {
        border: "none",
        margin: "0",
        padding: "0",
        width: "auto",
        background: "transparent",
        color: "inherit",
        font: "inherit",
        lineHeight: "normal"
      },
      "& .star-wrapper": {
        display: "inline-block"
      }
    }
  };
};

exports.styles = styles;